import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/paperspace/caldiy-private/releases/20260927-pilot-01/apps/web/components/PageWrapperAppDir.tsx");
;
import(/* webpackMode: "eager" */ "/home/paperspace/caldiy-private/releases/20260927-pilot-01/node_modules/next/dist/client/script.js");
